//  Name: login
import { mapGetters } from 'vuex'
import EventBus from '@/helpers/event-bus'
import { EVENTS } from '@/helpers/linkedin'
import { LOGO } from '@/config'
import { API } from '@/config'
import '@/components/g-button'
import '@/components/fb-button'
import '@/components/in-button'

export default {
  data () {
    return {
      logo: LOGO,
      user: {
        username: null,
        password: null
      },
      error: null,
      api: API,
      processing: false
    }
  },
  watch: {
    status (val) {
      // TODO: Hacer algo más elegante y respetable que esto
      this.processing = val
    }
  },
  computed: {
    ...mapGetters([
      'message',
      'status',
      'isLoggedIn'
    ])
  },
  methods: {
    login() {
      var vm = this
      vm.$validator.validateAll().then(() => {
        vm.$store.dispatch("login", this.user)
        .then(() => {
          if (vm.isLoggedIn) {
            vm.$router.push("/dashboard")
          }
        })
      })
    },
    communication (social, type, data) {
      var vm = this
      if (type === 'LOGIN' || type === 'WAITING') {
        EventBus.$emit('waitMessage')
        this.processing = true
      } else if (type === 'SUCCESS') {
        var event = {
          name: social,
          data: data
        }
        this.$store.dispatch("auth", event)
        .then(() => {
          if (vm.isLoggedIn) {
            vm.$router.push("/dashboard")
          }
        })
      } else {
        this.processing = false
        if (type === 'FAILED_AUTH') {
          EventBus.$emit('errorMessage', data)
        } else {
          EventBus.$emit('errorMessage', 'Ha ocurrido un problema de comunicación con el servidor')
        }
      }
    }
  },
  mounted () {

  }
}



// WEBPACK FOOTER //
// ./src/pages/login/script.js